export const setAuthHeader = (headers) => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
        headers.set('Authorization', `Bearer ${token}`);
        headers.set('X-Request-Source', 'admin');
    }
};